<template>
  <el-dialog
    ref="viewDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h720_dialog abow_dialog"
    width="1100px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="dialogViewForm"
      :model="dialogViewForm"
      class="add-edit-view-form"
      @submit.native.prevent
    >
      <div class="modal-box">
        <h3 class="modal-title">
          基础信息
        </h3>
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="动作分类">
                <el-radio-group
                  v-model="dialogViewForm.type"
                  disabled
                >
                  <el-radio :label="1">
                    客情维护
                  </el-radio>
                  <el-radio :label="2">
                    终端宣传
                  </el-radio>
                  <el-radio :label="3">
                    品牌推广
                  </el-radio>
                  <el-radio :label="4">
                    经营指导
                  </el-radio>
                  <el-radio :label="5">
                    终端调研
                  </el-radio>
                  <el-radio :label="6">
                    资料采集
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="默认动作">
                <el-radio-group
                  v-model="dialogViewForm.isDefault"
                  disabled
                >
                  <el-radio :label="1">
                    是
                  </el-radio>
                  <el-radio :label="2">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="动作名称">
                <el-input
                  v-model="dialogViewForm.name"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规定要求">
                <el-radio-group
                  v-model="dialogViewForm.actionRequire"
                  disabled
                >
                  <el-radio :label="1">
                    照片
                  </el-radio>
                  <el-radio :label="2">
                    调研问题
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="省区">
                <el-input
                  v-model="dialogViewForm.provinceName"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="城市">
                <el-input
                  v-model="dialogViewForm.cityName"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="适用终端">
                <el-input
                  v-model="dialogViewForm.terminalTypeValue"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="dialogViewForm.actionRequire === 1"
              :span="6"
            >
              <el-form-item label="照片数量">
                <el-input-number
                  v-model="dialogViewForm.imageNum"
                  disabled
                  :controls="false"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="dialogViewForm.actionRequire === 2"
              :span="6"
            >
              <el-form-item label="问题数量">
                <el-input-number
                  v-model="dialogViewForm.questionNum"
                  disabled
                  :controls="false"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="动作规定详细说明">
                <el-input
                  v-model="dialogViewForm.description"
                  type="textarea"
                  :autosize="{minRows: 3}"
                  disabled
                  class="textarea-item"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="dialogViewForm.actionRequire === 2">
            <el-col :span="24">
              <el-table
                border
                size="mini"
                :data="actionQuestionDataList"
                class="draggable-table"
                style="width: 100%; margin:10px 0px;"
                :header-cell-style="{background:'#0076ff'}"
              >
                <el-table-column
                  label="序号"
                  prop="orderNum"
                  width="60"
                  align="center"
                />
                <el-table-column
                  label="问题类别"
                  prop="questionTypeValue"
                  align="center"
                  width="80"
                />
                <el-table-column
                  label="问题内容(题干)"
                  prop="questionStem"
                  header-align="center"
                  show-overflow-tooltip
                />
              </el-table>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="modal-box">
        <h3 class="modal-title">
          备注信息
        </h3>
        <div class="modal-row-box">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item prop="remark">
                <el-input
                  v-model="dialogViewForm.remark"
                  type="textarea"
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="modalClose">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 终端走访配置动作API
import { viewTerminalVisitConfigActionApi } from '@/api/v2/terminalVisitConfigAction'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogViewForm: {},
      actionQuestionDataList: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this;
        _this.dialogViewForm = {}
        _this.actionQuestionDataList = []

        // 获取配置动作信息
        _this.initConfigActionData()
        _this.$nextTick(() => {
        })
      }
    },
  },
  methods: {
    // 初始化对象数据
    initConfigActionData() {
      let _this = this;
      viewTerminalVisitConfigActionApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogViewForm = data;
        _this.actionQuestionDataList = data.configActionQuestionDtoList || [];
      })
    },
    // 关闭弹框
    modalClose() {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.textarea-item {
  ::v-deep .el-textarea__inner {
    margin-top: 0px;
  }
}

.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
